/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UserAccountEffects } from './user-account.effects';
import { featureKey } from './user-account.selectors';
import { userAccountReducer } from './user-account.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature(featureKey, userAccountReducer),
        EffectsModule.forFeature([UserAccountEffects]),
    ],
})
export class UserAccountModule {}
